<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
  <g fill="none" fill-rule="evenodd">
    <rect width="24" height="24" fill="#AAEBCE" rx="12"/>
    <circle cx="12" cy="12" r="5" fill="#3DD7AB"/>
  </g>
</svg>
